export const PRODUCTS = {
  gnts1: {
    id: "gnts1",
    slug: "/gnts1-bluetooth-smart-sticker",
    name: "GNTS1",
    fullName: "GNTS1 Bluetooth Smart Sticker",
    category: "Partner detection network",
    pill: { label: "Bluetooth", tone: "cyan" },
    proposition:
      "A thin, disposable Bluetooth smart sticker whose secure, encrypted signal is detected by compatible devices across a rapidly expanding partner network of 100M+ participating devices — and relayed securely to the cloud for visibility through GoAndTrack.",
    networkStat: "100M+ devices in the expanding detection network",
    networkNote: true,
    bestFor: [
      "Item- and carton-level tagging at scale",
      "Visibility along busy lanes, hubs and populated routes",
      "High-volume shipments where per-unit cost matters most",
      "Returnable packaging and asset visibility without per-asset SIMs",
    ],
    capabilities: [
      "Emits a secure, encrypted Bluetooth signal designed for authorised detection events",
      "Detected by partner-enabled smartphones, compatible wireless access points, IoT infrastructure and integrated vehicle telematics",
      "Each detection event is associated with the detector's available location and relayed securely to the cloud",
      "No SIM card, GPS receiver or cellular modem inside the sticker",
      "Unique ID per sticker for item-level history",
      "Cut-to-activate tab — no pairing, buttons or chargers",
      "Setup guide printed on every sticker via QR code",
      "Single-use by design — disposable after delivery",
    ],
    locationMethod: {
      title: "How the GNTS1 produces a location",
      body: [
        "The GNTS1 contains no GPS receiver, no cellular modem and no SIM card. Instead, it emits a secure, encrypted Bluetooth signal containing the information required for an authorised detection event.",
        "That signal can be detected by compatible, participating devices and infrastructure — partner-enabled smartphones, wireless access points, IoT gateways and integrated vehicle telematics systems — across a rapidly expanding partner network of more than 100 million devices.",
        "When a participating device detects the signal, it associates the detection with its available location and securely relays the event to the cloud. The resulting location event is then displayed in GoAndTrack for operational visibility, route history and supported workflows.",
      ],
    },
    activation:
      "Cut the dotted line on the sticker's edge to activate — only when the shipment is ready. A QR code printed on every sticker links to the setup guide at goandtrack.com/start/s1.",
    operatingLife:
      "Up to [X] months depending on broadcast interval and conditions — confirm current figures with GoAndTrack.",
    certifications: [
      { name: "CE", status: "Marked on product" },
      { name: "FCC", status: "FCC ID 2AMLF-PB708 · Model PB708" },
      { name: "RoHS / WEEE", status: "Marked on product" },
      { name: "Air freight", status: "Zinc-ion battery — airplane compliant per manufacturer packaging; airline and IATA rules still apply" },
    ],
    goandtrack: [
      "Location events shown on map and list views per sticker",
      "Detection history with timestamps and detecting-device context",
      "Route history and supported operational workflows",
      "CSV / API export of detection records [confirm scope]",
    ],
    limitations: [
      "Detection depends on the presence, configuration, permissions and connectivity of compatible participating devices",
      "Network size does not guarantee detection at a particular location, on a particular route, or at a fixed interval",
      "No onboard positioning — the sticker never computes its own location",
      "No onboard temperature, humidity or shock sensing [confirm variant roadmap]",
    ],
    specs: [
      { k: "Model", v: "PB708 (Smart Sticker S1)" },
      { k: "Architecture", v: "Secure, encrypted Bluetooth broadcast + partner detection network" },
      { k: "Onboard positioning", v: "None — detection events carry the participating detector's available location" },
      { k: "Connectivity", v: "Bluetooth Low Energy (BLE) — no cellular radio" },
      { k: "SIM requirement", v: "None — no SIM card in the sticker" },
      { k: "Detection network", v: "100M+ participating devices, rapidly expanding" },
      { k: "Battery", v: "Zinc-ion — eco-friendly, airplane compliant" },
      { k: "Battery life", v: "Up to [X] months — interval- and condition-dependent" },
      { k: "Form factor", v: "Ultra-thin adhesive smart sticker [dimensions to confirm]" },
      { k: "Sensors", v: "[To verify against datasheet]" },
      { k: "Operating temperature", v: "[To verify against datasheet]" },
    ],
    datasheet: { label: "GNTS1 datasheet (PDF)", url: "", note: "[Datasheet asset pending — link added once approved]" },
    images: [
      {
        url: "https://customer-assets-lqy194kg.emergentagent.net/job_pilot-launch-hub/artifacts/l0kjnamx_gnts1-smartsticker.png",
        alt: "GNTS1 Smart Sticker S1 close-up showing the cut-to-activate tab, QR setup code and CE, FCC, RoHS and WEEE marks",
      },
      {
        url: "https://customer-assets-lqy194kg.emergentagent.net/job_pilot-launch-hub/artifacts/l97snuzx_gnts1-smartsticker2.png",
        alt: "GNTS1 Smart Sticker S1 beside its eco-friendly retail packaging",
      },
      {
        url: "https://customer-assets-lqy194kg.emergentagent.net/job_pilot-launch-hub/artifacts/cmnd0nuk_gnts1-smartsticker3.png",
        alt: "GNTS1 Smart Sticker S1 applied to a shrink-wrapped pallet in a warehouse aisle",
      },
      {
        url: "https://customer-assets-lqy194kg.emergentagent.net/job_pilot-launch-hub/artifacts/eujbj6qz_gnts1-smartsticker4.png",
        alt: "GNTS1 Smart Sticker S1 applied to a cardboard parcel on a packing bench",
      },
      { url: "/assets/use-cases/gnts1-palletised-freight.jpg", alt: "GNTS1 Smart Sticker S1 on shrink-wrapped palletised freight with a forklift working behind" },
      { url: "/assets/use-cases/gnts1-ecommerce-fulfilment.jpg", alt: "GNTS1 Smart Sticker S1 on a carton moving along an e-commerce fulfilment conveyor" },
      { url: "/assets/use-cases/gnts1-returnable-packaging.jpg", alt: "GNTS1 Smart Sticker S1 on a grey returnable transit tote among stacked containers" },
      { url: "/assets/use-cases/gnts1-construction-site-delivery.jpg", alt: "GNTS1 Smart Sticker S1 on a strapped pallet delivered to a construction site" },
    ],
    faqs: [
      {
        q: "Does the GNTS1 contain GPS?",
        a: "No. GNTS1 does not contain its own GPS receiver. It emits a secure, encrypted Bluetooth signal which can be detected by compatible devices in the partner network. The detecting device associates the event with its available location and relays it to the cloud.",
      },
      {
        q: "Does GNTS1 need a SIM card?",
        a: "No. The sticker does not need its own SIM card or cellular subscription. It relies on compatible participating devices and infrastructure to detect its Bluetooth signal and securely relay an event.",
      },
      {
        q: "Can any smartphone detect the sticker?",
        a: "Not automatically. Detection requires a compatible, participating device with the necessary partner technology, configuration, permissions and connectivity — not every nearby phone will detect or report the sticker.",
      },
      {
        q: "How large is the detection network?",
        a: "The partner ecosystem currently includes more than 100 million participating devices and is rapidly expanding. This describes the scale of the overall network — not guaranteed device density or coverage at every location.",
      },
      {
        q: "Is GNTS1 continuously tracked?",
        a: "No fixed detection interval is promised. A location event is created when the sticker encounters compatible participating infrastructure capable of detecting and relaying its signal.",
      },
      {
        q: "How is the LL100 different?",
        a: "LL100 has its own cellular connection and can send information to the cloud through mobile networks. It also supports multiple location inputs and condition sensors. GNTS1 instead uses an external partner-device network to detect and relay its Bluetooth signal.",
      },
      {
        q: "How do I activate the sticker?",
        a: "Cut the dotted line on the sticker's edge — do this only when the shipment is ready to move. There's no pairing, app setup or charging. A QR code on every sticker links to the setup guide at goandtrack.com/start/s1.",
      },
      {
        q: "How long does the battery last?",
        a: "The S1 runs on a zinc-ion battery — eco-friendly and airplane compliant. Battery life is measured in months and depends on the broadcast interval and operating conditions. We use \u201Cup to\u201D figures deliberately — confirm the current rated life for your intended configuration with GoAndTrack.",
      },
      {
        q: "Can I use the GNTS1 on air freight?",
        a: "The S1's zinc-ion battery is airplane compliant per the manufacturer's packaging, and the sticker is Bluetooth-only with no cellular radio. Airline and IATA rules still apply and vary by carrier — confirm acceptance on your specific routes with GoAndTrack before booking air freight pilots.",
      },
    ],
    lastReviewed: "2026-08-20 — partner-network positioning approved; imagery, model and certifications verified from approved assets",
    crossSell: "ll100",
  },
  ll100: {
    id: "ll100",
    slug: "/ll100-4g-smart-label",
    name: "LL100",
    fullName: "LL100 4G Cellular Smart Label",
    category: "Cellular/GNSS architecture",
    pill: { label: "4G Cellular + GNSS", tone: "lime" },
    proposition:
      "A cellular-enabled smart label that determines or assists its location using GNSS, Wi-Fi, Bluetooth and supported network methods — then transmits location and condition data to the cloud over its own cellular connection.",
    bestFor: [
      "Higher-risk shipments requiring autonomous reporting",
      "Door-to-door visibility without depending on a participating detector",
      "Pharma cold-chain and GDP-regulated lanes needing position history",
      "Remote or unaccompanied legs where richer sensor information matters",
    ],
    capabilities: [
      "Multiple location inputs: GNSS satellite positioning, Wi-Fi positioning, Bluetooth scanning and supported cellular-network-assisted methods",
      "Integrated cellular connectivity (eSIM) relays data to the cloud — no participating detector required",
      "Configurable reporting intervals to balance battery life vs update frequency",
      "Position history, geofence events and route playback in GoAndTrack",
      "Peel-strip activation — remove the tab marked \u201Cpeel here\u201D before use",
      "Unique barcode serial printed on every label",
      "Slim label format suited to parcels, pallets and containers",
    ],
    locationMethod: {
      title: "How the LL100 produces a location",
      body: [
        "The LL100 is a cellular-enabled smart label. It can determine or assist its location using GNSS satellite positioning, Wi-Fi positioning inputs, Bluetooth scanning and supported cellular-network-assisted methods.",
        "It then uses its own integrated cellular connection to relay location and condition data to the cloud — it does not depend on encountering a participating Bluetooth detector to report an event.",
        "This gives it a more autonomous reporting architecture than the GNTS1. Note that cellular-network location accuracy can vary significantly with network conditions and the positioning method available — cellular positioning is not universally equivalent to GNSS.",
      ],
    },
    activation: "Peel off the activation strip marked \u201Cpeel here — remove before use\u201D, apply the label to the shipment, and it begins reporting on its first position fix.",
    operatingLife:
      "Up to [X] days/weeks depending on reporting interval and signal conditions — confirm current figures with GoAndTrack.",
    certifications: [
      { name: "CE / FCC", status: "[Certificate references pending from GoAndTrack]" },
      { name: "Air freight / flight mode", status: "[To verify — cellular devices require an approved flight mode; confirm per airline]" },
      { name: "Network certifications", status: "[To verify — supported LTE bands and roaming agreements]" },
    ],
    goandtrack: [
      "Live map with position history and route playback",
      "Geofence entry/exit events and alerts",
      "Configurable reporting profiles per shipment",
      "CSV / API export of tracking records [confirm scope]",
    ],
    limitations: [
      "Higher per-unit cost than the GNTS1 — best reserved for shipments that justify it",
      "Requires supported cellular coverage; gaps in coverage delay updates until reconnection",
      "Cellular-network location accuracy varies with conditions — not universally equivalent to GNSS",
      "Air freight use requires a verified flight mode and airline acceptance [to verify]",
    ],
    specs: [
      { k: "Model", v: "LL100-EAL V1.5" },
      { k: "Architecture", v: "Cellular-enabled label — GNSS, Wi-Fi, Bluetooth and supported network-positioning inputs" },
      { k: "Onboard positioning", v: "GNSS satellite positioning, with Wi-Fi / Bluetooth / network-assisted support" },
      { k: "Connectivity", v: "Integrated cellular (eSIM) [bands to verify]" },
      { k: "SIM requirement", v: "Integrated cellular connectivity / eSIM" },
      { k: "Reporting interval", v: "Configurable — deployment-dependent" },
      { k: "Battery life", v: "Up to [X] — strongly dependent on reporting interval" },
      { k: "Form factor", v: "Slim adhesive smart label [dimensions to confirm]" },
      { k: "Sensors", v: "[To verify against datasheet]" },
      { k: "Operating temperature", v: "[To verify against datasheet]" },
    ],
    datasheet: { label: "LL100 datasheet (PDF)", url: "", note: "[Datasheet asset pending — link added once approved]" },
    images: [
      { url: "/assets/ll100/ll100-hero.jpg", alt: "LL100 4G smart label close-up showing the peel-here activation strip and barcode serial" },
      { url: "/assets/ll100/ll100-montage.jpg", alt: "A stack of LL100 4G smart labels ready for deployment" },
      { url: "/assets/ll100/ll100-on-box.jpg", alt: "LL100 4G smart label applied to a cardboard carton in a warehouse" },
      { url: "/assets/ll100/ll100-peel.jpg", alt: "Removing the peel-here activation strip from an LL100 label" },
      { url: "/assets/ll100/ll100-scan.jpg", alt: "Warehouse operative scanning a carton carrying an LL100 smart label" },
    ],
    faqs: [
      {
        q: "How is the LL100 different from the GNTS1?",
        a: "The LL100 is a cellular-enabled smart label: it determines or assists its own location using GNSS, Wi-Fi, Bluetooth and supported network methods, then transmits data to the cloud through its own cellular connection. The GNTS1 instead emits a secure Bluetooth signal detected and relayed by the partner device network — no SIM, lower per-unit cost.",
      },
      {
        q: "Is cellular positioning as accurate as GPS?",
        a: "Not universally. GNSS outdoors is the precise input; Wi-Fi positioning, Bluetooth scanning and cellular-network-assisted methods can vary significantly with network conditions and environment. The label uses the best input available at each moment.",
      },
      {
        q: "Does it work indoors or inside containers?",
        a: "GNSS needs a view of the sky. Indoors or inside metal containers, the label can draw on Wi-Fi positioning, Bluetooth scanning or supported network-assisted methods, or pause until the next fix — accuracy varies with the method and environment. [Fallback detail to confirm.]",
      },
      {
        q: "How often does it report its position?",
        a: "Reporting intervals are configurable per deployment. More frequent updates give finer-grained history but consume battery faster — the trade-off is set during pilot configuration.",
      },
      {
        "q": "Can the LL100 fly on aircraft?",
        a: "Cellular tracking devices generally require an approved flight mode and airline acceptance. [Status to be verified — confirm with GoAndTrack before air freight deployments.]",
      },
    ],
    lastReviewed: "2026-08-20 — cellular/GNSS positioning approved; imagery, model and activation verified from approved assets",
    crossSell: "gnts1",
  },
};

export const productList = [PRODUCTS.gnts1, PRODUCTS.ll100];
